<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 md-layout justify-end px-0">
      <div class="md-layout-item md-small-size-100 md-size-30 mt-5 md:mt-0">
        <md-field>
          <label>{{ $t("student.program") }}</label>
          <md-select v-model="program_id" name="program" id="program">
            <md-option
              v-for="(program, index) in programList"
              :key="program.name + index"
              :value="program.id"
            >
              {{ program.name }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>

    <div class="md-layout-item md-size-70 md-medium-size-100 px-0">
      <!-- GREETING -->
      <div class="md-layout-item">
        <greeting :info="info"></greeting>
      </div>
      <!-- GREETING -->

      <div class="md-layout">
        <!-- CLASSES IN PROGRESS -->
        <div class="md-layout-item md-size-100">
          <card-dashboard
            v-if="!program_id || !classesData"
            :title="$t('dashboard.class_in_progress', { length: 0 })"
          >
            <div class="flex justify-center">
              <no-data-found></no-data-found>
            </div>
          </card-dashboard>
          <classes-in-progress-student
            v-else
            :classesData="classesData"
          ></classes-in-progress-student>
        </div>
        <!-- CLASSES IN PROGRESS -->

        <!-- GRADE CHART -->
        <div class="md-layout-item md-size-50 md-small-size-100">
          <div ref="cardGradeLetter">
            <card-dashboard :title="$t('dashboard.grade_letter')">
              <div class="flex justify-center" v-if="!program_id || !dataGrade">
                <no-data-found></no-data-found>
              </div>
              <div class="md-layout justify-center" v-else>
                <div class="md-layout-item md-large-size-80 md-size-70">
                  <grade-chart-student :grade="dataGrade"></grade-chart-student>
                </div>
              </div>
            </card-dashboard>
          </div>
        </div>
        <!-- GRADE CHART -->

        <!-- CREDITS PERCENTAGE -->
        <div class="md-layout-item md-size-50 md-small-size-100">
          <card-dashboard
            :title="$t('dashboard.credits_percentage')"
            :style="{ height: heightChart }"
          >
            <div
              class="flex justify-center"
              v-if="!program_id || !creditsPercentage"
            >
              <no-data-found></no-data-found>
            </div>
            <credits-percentage
              :data="creditsPercentage"
              v-else
            ></credits-percentage>
          </card-dashboard>
        </div>
        <!-- CREDITS PERCENTAGE -->
      </div>

      <!-- DATA SYNTHETIC -->
      <synthetic-student :data="dataSynthetic"></synthetic-student>
      <!-- DATA SYNTHETIC -->
    </div>

    <div class="md-layout-item md-size-30 md-medium-size-100 px-0">
      <external-link></external-link>
      <!-- UPCOMING EVENTS -->
      <upcoming-events
        :path="path.upcomingEvents"
        :showTakeAttendance="false"
      ></upcoming-events>
      <!-- UPCOMING EVENTS -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import UpcomingEvents from "../../Components/UpcomingEvents";
import CardDashboard from "../../Components/CardDashboard";
import GradeChartStudent from "./GradeLetter";
import { service_paths } from "@/constants/Services";
import { getId, initLoader } from "@/helpers/utils";
import SyntheticStudent from "./Synthetic";
import CreditsPercentage from "./CreditsPercentage";
import ClassesInProgressStudent from "./Classes";
import Greeting from "../../Components/Gretting";
import NoDataFound from "@/components/Base/Illustration/NoDataFound";
import ExternalLink from "../../Components/ExternalLink";
import Role from "../../../../constants/Role";

export default {
  name: "dashboard-student",
  components: {
    ExternalLink,
    NoDataFound,
    Greeting,
    ClassesInProgressStudent,
    CreditsPercentage,
    SyntheticStudent,
    GradeChartStudent,
    CardDashboard,
    UpcomingEvents
  },
  data() {
    const defaultProgramId = null;

    return {
      path: {
        program: `${service_paths.programs}`,
        upcomingEvents: `${service_paths.calendars}/current-user/dashboard`,
        gradeChart: `${service_paths.reports}/score/grade-letter`,
        synthetic: `${service_paths.dashboard}/cpa/summary`,
        classesProgress: `${service_paths.classes}/in-process`,
        creditPercentage: `${service_paths.user_academic_plan}`
      },
      programList: [],
      program_id: defaultProgramId,
      dataGrade: null,
      creditsPercentage: {},
      classesData: null,
      dataSynthetic: {},
      heightChart: ""
    };
  },
  computed: {
    ...mapState("user", ["info"])
  },
  watch: {
    program_id(value) {
      if (value) {
        this.fetchDataCreditsPercentage(value);
        this.fetchDataSynthetic(value);
        this.fetchDataClasses(value);
        this.fetchDataGradeLetter(value);
      }
    },
    dataGrade() {
      this.getHeight();
    }
  },
  created() {
    const loader = initLoader();

    Promise.all(this.getProgramList()).finally(() => {
      loader.hide();
    });
  },
  methods: {
    getProgramList() {
      return this.$axios
        .get(
          `${this.path.program}`,
          { user_id: getId(this.info) },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          if (data) {
            this.programList = data.data;
            this.program_id = this.programList[0]?.id;
          }
        });
    },

    fetchDataGradeLetter(programId) {
      this.$axios
        .get(
          `${this.path.gradeChart}`,
          { student_id: getId(this.info), program_id: programId },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.dataGrade = data.data.length ? data : false;
        });
    },

    fetchDataCreditsPercentage(programId) {
      const uuid = this.info.uuid;
      this.$axios
        .get(`${this.path.creditPercentage}/${uuid}/${programId}`)
        .then(({ data }) => {
          if (data) {
            const { earned, missing, needed } = data.total;
            this.creditsPercentage = {
              earned,
              missing,
              needed
            };
          } else {
            this.creditsPercentage = false;
          }
        });
    },

    fetchDataSynthetic(programId) {
      this.$axios
        .get(`${this.path.synthetic}`, { program_id: programId })
        .then(({ data }) => {
          if (data) {
            this.dataSynthetic = data;
          }
        });
    },

    fetchDataClasses(programId) {
      const uuid = this.info.uuid;
      this.$axios
        .get(
          `${this.path.classesProgress}/${uuid}/user`,
          { program_id: programId },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.classesData = data.total ? data : false;
        });
    },

    getHeight() {
      this.$nextTick(() => {
        this.heightChart = this.$refs.cardGradeLetter.clientHeight + "px";
      });
    }
  }
};
</script>
